<div class="pismo-display-transactions-page m-4">
  <div fxLayout="column" fxLayoutGap="5px">
    <div>
      <breadcrumb (events)="onBreadcurmbEvents($event)" [trails]="breadcrumbTrails"></breadcrumb>
    </div>
    <h3 mat-dialog-title>Pismo transactions</h3>
  </div>
  @if (stage === 'init') {
    Loading ...
  }
  @if (stage === 'done') {
    <overdraft-account-transactions
      [pismoAccountNumber]="pismoAccountNumber"
      [getPismoTransactionsFn]="getPismoTransactionsFn"
      [getTransactionDetailsFn]="getTransactionDetailsFn"
      [getPismoAccountDetailsFn]="getPismoAccountDetailsFn"
      [getCardFn]="getCardFn"
      [getTransactionFromTimelineFn]="getTransactionFromTimelineFn"
      [clearPendingTransactionFn]="clearPendingTransactionFn"
    ></overdraft-account-transactions>
  }
  @if (stage === 'error') {
    <message-box type="warn">
      Unable to load transactions, missing required parameters
    </message-box>
  }
</div>
